export function validateStep() {
    const mandatoryFields = document.querySelectorAll('.mandatory-input');
    let isValid = true;

    mandatoryFields.forEach((field) => {
        const fieldType = field.type || field.tagName.toLowerCase();
        if (fieldType === "div") {
            validateParentContainer(field);
        } else {
            validateGenericField(field);
        }

    });

    if (!isValid) {
        document.querySelector(".error").scrollIntoView({ behavior: "smooth", block: "center" });
    }

    return isValid;

    // Generic validation for most input types
    function validateGenericField(field) {
        if (field.type === "checkbox" && !field.checked) {
            field.classList.add("error");
            isValid = false;
        } else if (!field.value || field.value.trim() === "") {
            field.classList.add("error");
            isValid = false;
        } else if (field.type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regex.test(field.value)) {
                field.classList.add("error");
                isValid = false;
            }
        } else if (field.type === "tel") {
            const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
            if (!regex.test(field.value)) {
                field.classList.add("error");
                isValid = false;
            }
        }
        else {
            field.classList.remove("error");
        }
    }

    // Validation for parent containers (e.g., divs with child inputs)
    function validateParentContainer(field) {
        const childInputs = field.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        if (childInputs.length > 0) {
            const isChecked = Array.from(childInputs).some((input) => input.checked);

            if (!isChecked) {
                field.classList.add("error");
                isValid = false;
            } else {
                field.classList.remove("error");
            }
        }
    }
}